var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import * as Styled from "./thumbnail-generator.style";
import { createThumbnailJobs } from "3d/thumbnails/thumbnail-jobs";
import { ThumbnailRenderer, thumbnailSizePx, } from "3d/thumbnails/thumbnail-renderer";
/**
 * Dev-only page (`PageRoute.DEV_THUMBNAILS`) that renders the cup mounting and
 * tube connection thumbnails from their 3D models. It is driven by
 * `scripts/generate-thumbnails.ts` through `window.__thumbnailGenerator`, and
 * can be used by hand to preview the framing before a run.
 */
export var ThumbnailGeneratorPage = function () {
    var canvasRef = useRef(null);
    var _a = __read(useState(), 2), renderer = _a[0], setRenderer = _a[1];
    var _b = __read(useState("Loading the PlayCanvas project…"), 2), status = _b[0], setStatus = _b[1];
    var _c = __read(useState(false), 2), isRenderingAll = _c[0], setIsRenderingAll = _c[1];
    var _d = __read(useState({}), 2), results = _d[0], setResults = _d[1];
    var jobs = useMemo(createThumbnailJobs, []);
    useEffect(function () {
        var canvas = canvasRef.current;
        if (!canvas)
            return;
        var isMounted = true;
        ThumbnailRenderer.create(canvas)
            .then(function (created) {
            if (!isMounted)
                return;
            setRenderer(created);
            setStatus("Ready");
        })
            .catch(function (error) {
            setStatus("Failed to start PlayCanvas: ".concat(String(error)));
        });
        return function () {
            isMounted = false;
        };
    }, []);
    var renderJob = useCallback(function (jobId) { return __awaiter(void 0, void 0, void 0, function () {
        var job, imageSrc_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    job = jobs.find(function (_a) {
                        var id = _a.id;
                        return id === jobId;
                    });
                    if (!job)
                        throw new Error("There is no thumbnail job \"".concat(jobId, "\""));
                    if (!renderer)
                        throw new Error("The renderer is not ready yet");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, renderer.render(job)];
                case 2:
                    imageSrc_1 = _a.sent();
                    setResults(function (previous) {
                        var _a;
                        return (__assign(__assign({}, previous), (_a = {}, _a[jobId] = { imageSrc: imageSrc_1 }, _a)));
                    });
                    return [2 /*return*/, imageSrc_1];
                case 3:
                    error_1 = _a.sent();
                    setResults(function (previous) {
                        var _a;
                        return (__assign(__assign({}, previous), (_a = {}, _a[jobId] = { error: String(error_1) }, _a)));
                    });
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [jobs, renderer]);
    var renderAll = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var jobs_1, jobs_1_1, job, e_1_1;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsRenderingAll(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    jobs_1 = __values(jobs), jobs_1_1 = jobs_1.next();
                    _b.label = 2;
                case 2:
                    if (!!jobs_1_1.done) return [3 /*break*/, 5];
                    job = jobs_1_1.value;
                    setStatus("Rendering ".concat(job.modelName, "\u2026"));
                    return [4 /*yield*/, renderJob(job.id).catch(function () { return undefined; })];
                case 3:
                    _b.sent(); // the error is shown on the card
                    _b.label = 4;
                case 4:
                    jobs_1_1 = jobs_1.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (jobs_1_1 && !jobs_1_1.done && (_a = jobs_1.return)) _a.call(jobs_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8:
                    setStatus("Done");
                    setIsRenderingAll(false);
                    return [2 /*return*/];
            }
        });
    }); }, [jobs, renderJob]);
    useEffect(function () {
        var api = {
            isReady: function () { return Boolean(renderer); },
            listJobs: function () { return jobs; },
            render: renderJob,
        };
        window.__thumbnailGenerator = api;
        return function () {
            delete window.__thumbnailGenerator;
        };
    }, [jobs, renderer, renderJob]);
    return (_jsxs(Styled.Page, { children: [_jsx("h1", { children: "Component thumbnails" }), _jsxs("p", { children: ["Renders every cup mounting and tube connection model with the scene's materials and lighting. Run", " ", _jsx("code", { children: "npm run thumbnails:generate" }), " to write the files into the project, or render here to preview the framing."] }), _jsxs(Styled.Toolbar, { children: [_jsx("button", { onClick: function () {
                            renderAll().catch(function () { return undefined; });
                        }, disabled: !renderer || isRenderingAll, children: "Render all" }), _jsx("span", { children: status })] }), _jsx(Styled.Stage, { children: _jsx("canvas", { ref: canvasRef, width: thumbnailSizePx, height: thumbnailSizePx }) }), _jsx(Styled.Grid, { children: jobs.map(function (job) {
                    var result = results[job.id];
                    return (_jsxs(Styled.Card, { children: [_jsx("strong", { children: job.modelName }), _jsx("small", { children: job.imagePath }), (result === null || result === void 0 ? void 0 : result.imageSrc) && (_jsx("img", { src: result.imageSrc, alt: job.modelName })), (result === null || result === void 0 ? void 0 : result.error) && (_jsx(Styled.ErrorText, { children: result.error })), _jsx("button", { onClick: function () {
                                    renderJob(job.id).catch(function () { return undefined; });
                                }, disabled: !renderer || isRenderingAll, children: "Render" })] }, job.id));
                }) })] }));
};
